/*
 * Copyright (C) 2019 - Potentially Ltd
 *
 * Please see distribution for license.
 */

import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MatLegacyAutocompleteSelectedEvent as MatAutocompleteSelectedEvent } from '@angular/material/legacy-autocomplete';
import { ReviewerDetails } from '@app/app/page-modules/playlist/models';
import { FeedbackProviderUser } from '@app/app/shared/models';
import { canTriggerSearch } from '../../helpers/content-helper';
import { UserSearch } from '../../models/admin/members.model';

@Component({
  selector: 'ptl-user-search-autocomplete-new',
  templateUrl: './user-search-autocomplete-new.component.html',
  styleUrls: ['./user-search-autocomplete-new.component.scss'],
})
export class UserSearchAutocompleteNewComponent {
  @Input() members: UserSearch[] | FeedbackProviderUser[] | ReviewerDetails[];
  @Input() label: string;
  @Input() loadingMembers: boolean;
  @Input() disabled: boolean;
  @Input() placeholder = 'Add new member';

  @Output() searchInputChanged = new EventEmitter<string>();
  @Output() searchLoadedMore = new EventEmitter<string>();
  @Output() memberSelected = new EventEmitter<UserSearch | FeedbackProviderUser | ReviewerDetails>();

  canLoadMore: boolean;
  isLoadingMore: boolean;

  private searchString: string;

  onFocus(): void {
    if (this.searchString === undefined) {
      this.searchString = '';
      this.searchInputChanged.emit('');
    }
  }

  onTextPaste(event: ClipboardEvent) {
    if (event.type === 'paste') {
      setTimeout(() => {
        this.searchString = (event.target as HTMLInputElement).value;
        this.searchInputChanged.emit(this.searchString);
      }, 0);
    }
  }

  onSearchInputChange(event: KeyboardEvent) {
    if (canTriggerSearch(event)) {
      this.searchString = (event.target as HTMLInputElement).value;
      this.searchInputChanged.emit(this.searchString);
    }
  }

  disabledAutocomplete(): string {
    return '';
  }

  onMemberSelected({ option }: MatAutocompleteSelectedEvent) {
    const data = option.value as UserSearch;
    this.memberSelected.emit(data);
  }

  onAutocompleteScroll() {
    if (!this.canLoadMore) {
      return;
    }
    if (!this.isLoadingMore) {
      this.searchLoadedMore.emit(this.searchString);
      this.isLoadingMore = true;
    }
  }
}
